import * as React from 'react';

// Custom hook for handling page changes
var usePageChangeHandler = function usePageChangeHandler(onPageChange) {
  return React.useCallback(function (api) {
    if (!api || !onPageChange) return;
    var selectedPage = api.selectedScrollSnap();
    var totalSlides = api.slideNodes().length;
    var scrollLeft = 0; // Currently not supported
    var scrollDirection = 'next'; // Currently not supported

    onPageChange(selectedPage, totalSlides, scrollLeft, scrollDirection);
  }, [onPageChange]);
};

export { usePageChangeHandler };
//# sourceMappingURL=usePageChangeHandler.js.map
